import { DictionarySupplier, DictionarySupplierSchema } from "etl/types";
import { createAppAsyncThunk } from "core/src/store/store.types";
import { ItemMapping } from "core/src/slices/etlData/slice/etlData.types";

export type PatchSupplierMappingRequest = {
	suppliersMapping: ItemMapping;
}

export type PatchSupplierMappingResponse = {
	dictionarySuppliers: DictionarySupplier[];
};

export const patchSupplierMapping = createAppAsyncThunk<PatchSupplierMappingResponse, PatchSupplierMappingRequest>(
	"patchSupplierMapping",
	async ({ suppliersMapping }, { extra, getState, rejectWithValue }) => {

		const { extractSuppliers, dictionarySuppliers } = getState().etlData;

		const tmpDictionarySuppliers = [...dictionarySuppliers];

		const extractSupplier = extractSuppliers.find((extractSupplier) => extractSupplier.id === suppliersMapping.extractId);
		const dictionnarySupplier = dictionarySuppliers.find((dictionarySupplier) => dictionarySupplier.id === suppliersMapping.dicoId);

		if (
			dictionnarySupplier?.hb_supplier_id === extractSupplier?.hb_id
			&& dictionnarySupplier?.hb_supplier_libelle === extractSupplier?.libelle
		) {
			return rejectWithValue("No changes");
		}

		if (extractSupplier && dictionnarySupplier) {
			const dictionarySuppliersUpdated = await extra.etlClient.update(
				DictionarySupplierSchema,
				dictionnarySupplier.id,
				{
					hb_supplier_id: extractSupplier?.hb_id,
					hb_supplier_libelle: extractSupplier?.libelle
				},
			);

			if (dictionarySuppliersUpdated) {
				tmpDictionarySuppliers.splice(
					tmpDictionarySuppliers.findIndex((supplier) => supplier.id === suppliersMapping.dicoId),
					1,
					dictionarySuppliersUpdated.data
				);
			}

		}

		return {
			dictionarySuppliers: tmpDictionarySuppliers
		}
	}
);
